import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { Job } from '../../JobSearchResult/types'

export const useGetJob = (externalSlugId?: string, sourceId?: string, source?: string) => {
  return useQuery(
    ['useGetJob', externalSlugId],
    async () => {
      const response = await baseClient.get<Job>(`/jobs/v1/search/${externalSlugId}`, {
        params: { source_id: sourceId, source },
      })
      return response.data
    },
    {
      enabled: !!externalSlugId,
      useErrorBoundary: false,
      refetchOnWindowFocus: false,
    },
  )
}
